import * as _ from 'underscore';

import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import StringField from '../../../../_common/platform/ts/StringField';

import * as validators from '../components/Validators';
import { validators as ValidatorPlatform } from '../../../../_common/platform/ts/validators';

import { themeId, themeFields, sections } from '../config';

// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';

// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

import { ThemePreview } from './ThemePreview';

// CSS template for the widget
const template = require('!!raw-loader!pdc-widget-grid/src/mainTheme.template.css').default;

// A hack, to make sure that TS compiler will include this module as dependency in generated AMD
template;

declare var Color: any;

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
var _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: themeId,
            name: 'Grid',
            parent: 'widget',
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-grid',

            themeType: 'Widget Grid',
            visibility: ['application', 'workspace', 'pdc-widget-grid', 'pdc-helpdesk-issue-grid']
        },
        {
            id: sections.rows,
            name: 'Rows',
            parent: themeId,
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-grid',

            themeType: 'Widget Grid',
            visibility: ['application', 'workspace', 'pdc-widget-grid', 'pdc-helpdesk-issue-grid']
        },
        {
            id: sections.groupRows,
            name: 'Group Rows',
            parent: themeId,
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-grid',

            themeType: 'Widget Grid',
            visibility: ['application', 'workspace', 'pdc-widget-grid', 'pdc-helpdesk-issue-grid']
        },
        {
            id: sections.toolbar,
            name: 'Toolbar and Search Panel',
            parent: themeId,
            preview: ThemePreview,
            previewClassName: 'preview-widget preview-widget-grid',

            themeType: 'Widget Grid',
            visibility: ['application', 'workspace', 'pdc-widget-grid', 'pdc-helpdesk-issue-grid']
        }
    ]);

    // gray-base    = main fore coloe
    // surface-bg   = main background

    appTheme.registerGroups([
        {
            id: themeFields.themeGroup_ColumnOptions,
            name: 'Column Options',
            section: themeId
        },
        {
            id: 'grid-panel-rows',
            name: 'Rows',
            section: sections.rows
        },
        {
            id: 'grid-group-row-options',
            name: 'Group Rows',
            section: sections.groupRows
        },

        {
            id: 'grid-lines-options',
            name: 'Grid Lines',
            section: themeId
        },
        {
            id: themeFields.themeGroup_Groupings,
            name: 'Groupings',
            section: themeId
        },
        {
            id: themeFields.themeGroup_Options,
            name: 'Others',
            section: themeId
        },
        {
            id: 'grid-group-toolbar',
            name: 'Grid Toolbar',
            section: sections.toolbar
        },

        {
            id: 'grid-group-search',
            name: 'Search Panel',
            section: sections.toolbar
        },
        {
            id: 'grid-group-column-chooser',
            name: 'Column Chooser Options',
            section: themeId
        },
        {
            id: 'grid-group-storeGridLayout',
            name: 'Store Grid Layout Options',
            section: themeId
        },
        {
            id: 'grid-group-dataRetrieving',
            name: 'Data Retrieving',
            section: themeId
        },
        {
            id: 'grid-group-scrolling',
            name: 'Scrolling',
            section: themeId
        },
        {
            id: themeFields.themeGroup_FilterRow,
            name: 'Filter Row',
            section: themeId
        },
        {
            id: themeFields.themeGroup_WordWrap,
            name: 'Word Wrap',
            section: themeId
        },
        {
            id: 'grid-experimental-Staffplan',
            name: 'Experimental for VoresPlan',
            section: themeId
        }
    ]);

    // Register theme variables
    appTheme.registerVars([
        {
            id: themeFields.showColumnHeaders,
            param: new BooleanField(glob, 'Show Column Headers', [], true),
            section: themeId,
            group: themeFields.themeGroup_ColumnOptions
        },
        {
            id: 'widget-grid-hd-color',
            param: new ColorBoxField(
                glob,
                'Header Font Color',
                [],
                function (theme) {
                    return theme['on-secondary'];
                },
                { hideTransparency: true }
            ),
            section: themeId,
            deps: ['on-secondary'],
            group: themeFields.themeGroup_ColumnOptions
        },
        {
            id: 'widget-grid-hdbg-color',
            param: new ColorBoxField(
                glob,
                'Header Background Color',
                [],
                function (theme) {
                    return theme['secondary-bg'];
                },
                { hideTransparency: false }
            ),
            section: themeId,
            deps: ['secondary-bg'],
            group: themeFields.themeGroup_ColumnOptions
        },
        {
            id: 'widget-grid-header-alignment',
            param: new SelectField(glob, 'Column Header Alignment', [], 'default', {
                values: ['default', 'left', 'center', 'right'],
                display: ['default', 'left', 'center', 'right']
            }),
            section: themeId,
            group: themeFields.themeGroup_ColumnOptions
        },

        {
            id: 'widget-grid-alignment',
            param: new SelectField(glob, 'Column Data Alignment', [], 'default', {
                values: ['default', 'left', 'center', 'right'],
                display: ['default', 'left', 'center', 'right']
            }),
            section: themeId,
            group: themeFields.themeGroup_ColumnOptions
        },
        {
            id: 'widget-grid-column-fix',
            param: new BooleanField(glob, 'Allow Column Fixing', [], true),
            section: themeId,
            group: themeFields.themeGroup_ColumnOptions
        },
        {
            id: 'widget-grid-column-resize',
            param: new BooleanField(glob, 'Allow Column Resizing', [], true),
            section: themeId,
            group: themeFields.themeGroup_ColumnOptions
        },
        {
            id: 'widget-grid-column-sorting',
            param: new BooleanField(glob, 'Allow Column Sorting', [], true),
            section: themeId,
            group: themeFields.themeGroup_ColumnOptions
        },
        {
            id: 'widget-grid-column-resizing-mode',
            param: new SelectField(glob, 'Column Resizing Mode', [], 'nextColumn', {
                values: ['nextColumn', 'widget'],
                display: [
                    'The width of the next column changes',
                    'The width of the Grid changes (ignored if width of any column is in percents)'
                ],
                tooltips: [
                    'The width of the next column changes',
                    'The width of the Grid changes (ignored if width of any column is in percents)'
                ]
            }),
            section: themeId,
            group: themeFields.themeGroup_ColumnOptions
        },
        {
            id: 'widget-grid-min-column-width',
            param: new NumberField(
                glob,
                'Min Column Width (px)',
                [
                    ValidatorPlatform.number.range(0, 50),
                    ValidatorPlatform.number.not_negative,
                    ValidatorPlatform.number.integer
                ],
                null,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: themeId,
            group: themeFields.themeGroup_ColumnOptions
        },

        // ROWS panel: ==================================================
        {
            id: 'widget-grid-row-color',
            param: new ColorBoxField(
                glob,
                'Row Font Color',
                [],
                function (theme) {
                    return theme['gray-base'];
                },
                { hideTransparency: true }
            ),
            section: sections.rows,
            deps: ['gray-base'],
            group: 'grid-panel-rows'
        },
        {
            id: 'widget-grid-rowbg-color',
            param: new ColorBoxField(
                glob,
                'Row Background Color',
                [],
                function (theme) {
                    return theme['surface-bg'];
                },
                { hideTransparency: false }
            ),
            section: sections.rows,
            deps: ['surface-bg'],
            group: 'grid-panel-rows'
        },
        {
            id: themeFields.rowHighligtingColor,
            param: new ColorBoxField(glob, 'Row Highligting Color', [], '#0D47A1', { hideTransparency: true }),
            section: sections.rows,
            deps: ['gray-base'],
            group: 'grid-panel-rows'
        },
        {
            id: 'widget-grid-row-alternation',
            param: new BooleanField(glob, 'Row Alternation', [], true),
            section: sections.rows,
            group: 'grid-panel-rows'
        },
        {
            id: themeFields.rowSelectionMode,
            param: new SelectField(glob, 'Row Selection Mode', [], 'none', {
                values: ['none', 'single', 'multiple'],
                display: ['none', 'single', 'multiple']
            }),
            section: sections.rows,
            group: 'grid-panel-rows'
        },
        {
            id: 'widget-grid-hover-enabled',
            param: new BooleanField(glob, 'Row Hover', [], true),
            section: sections.rows,
            group: 'grid-panel-rows'
        },
        {
            id: 'widget-grid-padding-top',
            param: new StringField(
                glob,
                'Padding top (auto|length specified in px, pt, cm, etc | %)',
                [validators.length.pixel_percent],
                '5px'
            ),
            section: sections.rows,
            group: 'grid-panel-rows'
        },
        {
            id: 'widget-grid-padding-bottom',
            param: new StringField(
                glob,
                'Padding bottom (auto|length specified in px, pt, cm, etc | %)',
                [validators.length.pixel_percent],
                '5px'
            ),
            section: sections.rows,
            group: 'grid-panel-rows'
        },
        {
            id: 'widget-grid-rowsum-color',
            param: new ColorBoxField(
                glob,
                'Summary Background Color',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.92).hexString();
                },
                { hideTransparency: true }
            ),
            section: sections.rows,
            deps: ['gray-base', 'surface-bg'],
            group: 'grid-panel-rows'
        },
        {
            id: 'widget-grid-row-height',
            param: new NumberField(
                glob,
                'Fixed row height in px, use 0 for none (0-1000)',
                [ValidatorPlatform.number.range(0, 1000), ValidatorPlatform.number.integer],
                0
            ),
            section: sections.rows,
            group: 'grid-panel-rows'
        },

        // Panel "Group Rows" ==========================================
        {
            id: 'widget-grid-grouprow-color',
            param: new ColorBoxField(
                glob,
                'Group Row Font Color',
                [],
                function (theme) {
                    return theme['gray-base'];
                },
                { hideTransparency: true }
            ),
            section: sections.groupRows,
            deps: ['gray-base'],
            group: 'grid-group-row-options'
        },
        {
            id: 'widget-grid-grouprow-bg-color',
            param: new ColorBoxField(
                glob,
                'Group Row Background',
                [],
                function (theme) {
                    return Color(theme['secondary-bg']).hexString();
                },
                // function (theme) {
                //     return theme['surface-bg'];
                // },
                { hideTransparency: false }
            ),
            section: sections.groupRows,
            deps: ['secondary-bg'],
            group: 'grid-group-row-options'
        },
        {
            id: 'widget-grid-grouprow-top-border',
            param: new NumberField(
                glob,
                'Width of top border (0-8)',
                [ValidatorPlatform.number.range(0, 8), ValidatorPlatform.number.integer],
                1
            ),
            section: sections.groupRows,
            group: 'grid-group-row-options'
        },
        {
            id: 'widget-grid-grouprow-bottom-border',
            param: new NumberField(
                glob,
                'Width of bottom border (0-8)',
                [ValidatorPlatform.number.range(0, 8), ValidatorPlatform.number.integer],
                1
            ),
            section: sections.groupRows,
            group: 'grid-group-row-options'
        },
        {
            id: 'widget-grid-grouprow-border-color',
            param: new ColorBoxField(
                glob,
                'Border Color',
                [],
                function (theme) {
                    return theme['gray-base'];
                },
                { hideTransparency: false }
            ),
            section: sections.groupRows,
            group: 'grid-group-row-options'
        },
        {
            id: 'widget-grid-sticky-grouprow',
            param: new BooleanField(glob, 'Sticky group rows', [], false),
            section: sections.groupRows,
            group: 'grid-group-row-options'
        },

        //LL: 27.10.21
        {
            id: 'widget-grid-grouprow-hide-buttons',
            param: new BooleanField(glob, 'Hide "expand/collapse" buttons (expand/collapse by row click)', [], false),
            section: themeId + '-group-rows',
            group: 'grid-group-row-options'
        },

        // Panel "Grid Lines" ==========================================
        {
            id: 'widget-grid-show-row-lines',
            param: new BooleanField(glob, 'Show Row Lines', [], true),
            section: themeId,
            group: 'grid-lines-options'
        },
        {
            id: 'widget-grid-show-column-lines',
            param: new BooleanField(glob, 'Show Column Lines', [], true),
            section: themeId,
            group: 'grid-lines-options'
        },
        {
            id: 'widget-grid-lines-color',
            param: new ColorBoxField(glob, 'Vertical & Horizontal Lines Color', [], '#DDDDDD', {
                hideTransparency: true
            }),
            section: themeId,
            group: 'grid-lines-options'
        },

        // Panel Toolbar
        {
            id: themeFields.showToolbar,
            param: new BooleanField(glob, 'Show Grid Toolbar', [], true),
            section: sections.toolbar,
            group: 'grid-group-toolbar'
        },
        {
            id: themeFields.showGroupPanel,
            param: new BooleanField(glob, 'Show Groups in Toolbar', [], true),
            section: sections.toolbar,
            group: 'grid-group-toolbar'
        },

        {
            id: themeFields.allowGrouping,
            param: new BooleanField(glob, 'Allow Grouping (not used with Endless Scrolling)', [], false),
            section: themeId,
            group: themeFields.themeGroup_Groupings
        },
        {
            id: themeFields.showCollapseGroupingsByDefault,
            param: new BooleanField(glob, 'Collapse Groupings By Default', [], false),
            section: themeId,
            group: themeFields.themeGroup_Groupings
        },
        {
            id: themeFields.allowGroupCollapsing,
            param: new BooleanField(glob, 'Allow Group Expanding/Collapsing', [], true),
            section: themeId,
            group: themeFields.themeGroup_Groupings
        },

        // Panel "Other Options" ==========================================
        {
            id: themeFields.useRowMode,
            param: new BooleanField(glob, 'Use Row Mode for Click-To-Filter', [], true),
            section: themeId,
            group: themeFields.themeGroup_Options
        },
        {
            id: themeFields.selectFirstRowOnUpdate,
            param: new BooleanField(glob, 'Select First Row when Grid is created or Data updated', [], false),
            section: themeId,
            group: themeFields.themeGroup_Options
        },
        {
            id: themeFields.showCollapseExpandButton,
            param: new BooleanField(glob, 'Show "Collapse All"/"Expand All" Button', [], false),
            section: themeId,
            group: themeFields.themeGroup_Options
        },
        //The whole background color:
        {
            id: 'widget-grid-bg-color',
            param: new ColorBoxField(
                glob,
                'Background Color',
                [],
                function (theme) {
                    return theme['surface-bg'] || '#FFFFFF';
                },
                {
                    hideTransparency: false
                }
            ),
            section: themeId,
            deps: ['surface-bg'],
            group: themeFields.themeGroup_Options
        },
        {
            id: themeFields.hideNoDataMessage,
            param: new BooleanField(glob, 'Hide "No Data" message', [], false),
            section: themeId,
            group: themeFields.themeGroup_Options
        },

        {
            id: themeFields.allowFilterRow,
            param: new BooleanField(glob, 'User can toggle Filter Row', [], false),
            section: themeId,
            group: themeFields.themeGroup_FilterRow
        },
        {
            id: themeFields.filterRowEnabled,
            param: new BooleanField(glob, 'Filter Row is enabled by default', [], false),
            section: themeId,
            group: themeFields.themeGroup_FilterRow
        },

        {
            id: themeFields.allowWordWrap,
            param: new BooleanField(glob, 'User can change Word Wrap', [], false),
            section: themeId,
            group: themeFields.themeGroup_WordWrap
        },

        {
            id: themeFields.wordWrapEnabled,
            param: new BooleanField(glob, 'Word Wrap is enabled by default', [], false),
            section: themeId,
            group: themeFields.themeGroup_WordWrap
        },

        {
            id: 'widget-grid-column-chooser-show',
            param: new BooleanField(glob, 'Show Column Chooser Button in Grid Toolbar', [], false),
            section: themeId,
            group: 'grid-group-column-chooser'
        },
        {
            id: 'widget-grid-reset-layout-button-show',
            param: new BooleanField(glob, 'Show Reset Layout Button in Grid Toolbar', [], false),
            section: themeId,
            group: 'grid-group-column-chooser'
        },

        {
            id: 'widget-grid-show-search',
            param: new BooleanField(glob, 'Show Search Panel', [], false),
            section: sections.toolbar,
            group: 'grid-group-search'
        },
        {
            id: 'widget-grid-search-panel-width',
            param: new NumberField(
                glob,
                'Search Panel Width',
                [ValidatorPlatform.number.range(50, 300), ValidatorPlatform.number.integer],
                120,
                {
                    applyOnEnter: true
                }
            ),
            section: sections.toolbar,
            group: 'grid-group-search'
        },
        {
            id: 'widget-grid-dataRetrieving-specialMainGroupHandling',
            param: new BooleanField(glob, 'Special Main Group Handling', [], false),
            section: themeId,
            group: 'grid-group-dataRetrieving'
        },
        {
            id: 'widget-grid-native-scrollbar',
            param: new BooleanField(glob, 'Use native scrollbar', [], true),
            section: themeId,
            group: 'grid-group-scrolling'
        },
        {
            id: 'widget-grid-scrolling-mode',
            param: new SelectField(glob, 'Scrolling Mode', null, 'virtual', {
                values: ['standard', 'virtual'],
                display: ['Standard', 'Virtual'],
                tooltips: [
                    'Faster scrolling, but may cause delays of group rows rendering',
                    'More smooth scrolling, but may cause the delays of data rows rendering'
                ]
            }),
            section: themeId,
            group: 'grid-group-scrolling'
        },

        {
            id: 'widget-grid-highlight-current-date',
            param: new BooleanField(glob, 'Highlight Current Date', [], false),
            section: themeId,
            group: 'grid-experimental-Staffplan'
        },
        {
            id: 'widget-grid-highlight-current-date-color',
            param: new ColorBoxField(glob, 'Current Date Highlighting Color', [], '#FA8128', {
                hideTransparency: true
            }),
            section: themeId,
            group: 'grid-experimental-Staffplan'
        },
        {
            id: 'widget-grid-virtual-scrolling-threshold',
            param: new NumberField(glob, 'Virtal Scrolling Mode Threshold (0 means no threshold)', [], 1000, {
                min: 0,
                applyOnEnter: true
            }),
            section: themeId,
            group: 'grid-experimental-Staffplan'
        }
    ]);

    // Register templates
    appTheme.registerTemplate(template, ['pdc-widget-grid']);

    appTheme.registerPreRender(function (input) {
        var vars = {};

        //color.luminosity();  //ex: 0.412 (0 is black, 1 is white.)
        // The [WCAG luminosity](http://www.w3.org/TR/WCAG20/#relativeluminancedef) of the color. 0 is black, 1 is white.

        //var colorArr = Color(input['widget-grid-rowbg-color']).rgbArray();
        //vars['widget-grid-rowbg-color-r'] = colorArr[0];
        //vars['widget-grid-rowbg-color-g'] = colorArr[1];
        //vars['widget-grid-rowbg-color-b'] = colorArr[2];
        //vars['widget-grid-rowbg-color-op'] = 1.0-(Color(input['widget-grid-rowbg-color']).luminosity()*0.8);
        //
        //var colorAltArr = Color(input['widget-grid-rowbgalt-color']).rgbArray();
        //vars['widget-grid-rowbgalt-color-r'] = colorAltArr[0];
        //vars['widget-grid-rowbgalt-color-g'] = colorAltArr[1];
        //vars['widget-grid-rowbgalt-color-b'] = colorAltArr[2];
        //vars['widget-grid-rowbgalt-color-op'] = 1.0-(Color(input['widget-grid-rowbgalt-color']).luminosity()*0.8);

        return _.extend(input, vars);
    });

    _init.push(glob);
}
